<template>
  <BLayoutList
    :title="pageTitle"
    :create-route="createRoute"
    :skeleton="isLoadingAsyncData"
  >
    <template v-if="canEdit" #before-add>
      <BMenuMore
        v-if="selected.length"
        :list="menuSelected"
        class="mr-2"
        @selected="onSelectSelectedMenu"
      />

      <BMenuMore
        :list="menuImport"
        :skeleton="isLoadingAsyncData"
        class="mr-2"
        @selected="onSelectImportMenu"
      >
        <template #activator>
          <v-btn depressed class="pr-1">
            <span>Импорт</span>
            <v-divider vertical class="ml-2 mr-1" />
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
      </BMenuMore>
    </template>

    <template #filter>
      <BListFilter
        label="Поиск по имени"
        :skeleton="isLoadingAsyncData"
        dense
        @change="onChangeFilter"
      />
    </template>

    <BTableCommon
      v-model="selectedValue"
      type="participants"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      :sortable-positions="canEdit"
      @change:pagination="onChangePagination"
      @change:sortable-positions="onUpdatePositions"
      @change:sort="onChangeSort"
      @action:delete="onDeleteWithRefresh"
      @action:copy="onCopy"
      @action:download="onDownloadList"
    />
  </BLayoutList>
</template>

<script>
import { createBAteTreeParticipantsImportModal } from '@/components/forms/BAteTree/utils'
import { lkParticipantPermissions as Permissions } from '@/helpers/enums/permission-models'
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { ParticipantsModel as Model } from './Model'
import {
  participantsStoreModule as StoreModule,
  participantsMapper as StoreMapper,
} from './store'
import { PARTICIPANTS_ROUTES as ROUTES } from './utils'

import BListFilter from '@/components/forms/BListFilter.vue'
import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import BMenuMore from '@/components/common/BMenuMore.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

const MENU_SELECTED = {
  EXPORT: { id: 'export', title: 'Выгрузить в excel' },
}

const MENU_IMPORT = {
  IMPORT_PARCIPIANT: {
    id: 'import_parcipiant',
    title: 'Импорт Участника',
  },
}

export default {
  name: 'ViewParticipantsList',
  components: {
    BListFilter,
    BLayoutList,
    BTableCommon,
    BMenuMore,
  },
  mixins: [
    listMixin,
  ],
  data: () => ({
    selected: [],
    menuImport: Object.values(MENU_IMPORT),
    menuSelected: Object.values(MENU_SELECTED),
  }),
  computed: {
    canEdit() {
      return this.$access(Permissions.edit)
    },
    createRoute() {
      const editable = this.$access(Permissions.create)
      return editable ? { name: ROUTES.CREATE } : void 0
    },
    selectedValue: {
      get() {
        return this.canEdit ? this.selected : void 0
      },
      set(val) {
        this.selected = val
      },
    },
  },
  methods: {
    ...StoreMapper.mapActions(['copy', 'exportParticipantUsers', 'exportParticipants']),

    async onSelectSelectedMenu(data) {
      switch (data.id) {
        case MENU_SELECTED.EXPORT.id:
          await this.onDownloadParticipantsList(this.selected)
          break

        default:
      }

      this.selected = []
    },
    async onCopy(params, callback) {
      const unwatch = callback?.()

      try {
        const { data } = await this.copy(params)
        const location = {
          name: ROUTES.EDIT,
          params: { id: data.id },
        }
        this.$router.push(location)
      } catch (e) {
        this.$notice.errors(e)
      }

      unwatch?.()
    },
    async onSelectImportMenu(data) {
      switch (data.id) {
        case MENU_IMPORT.IMPORT_PARCIPIANT.id: {
          const flag = await this.toUploadTreeParticipants()
          if (flag) this.onGetData(this.filters, false)
          break
        }

        default:
      }
    },
    async toUploadTreeParticipants() {
      const propsData = {}
      const modal = await createBAteTreeParticipantsImportModal(this, propsData)
      return modal.open()
    },
    onDownloadList({ id }) {
      this.isLoading = true

      try {
        this.exportParticipantUsers({ id })
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
    async onDownloadParticipantsList(participants) {
      this.isLoading = true

      try {
        await this.exportParticipants(participants)
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
